import * as Sentry from "@sentry/react";

const DSN = (import.meta.env.VITE_SENTRY_DSN ?? "").trim();
const TOKEN_RE = /fk_(live|sess|pub)_[A-Za-z0-9]+/g;
const HASH_TOKEN_RE = /#\/(invite|reset|auth\/google)\/[^/\s?#]+/g;

function scrubString(value: string): string {
  return value
    .replace(TOKEN_RE, "fk_$1_[Filtered]")
    .replace(HASH_TOKEN_RE, "#/$1/[Filtered]");
}

export function installSentry(): void {
  if (!DSN) return;
  Sentry.init({
    dsn: DSN,
    environment: import.meta.env.MODE,
    sendDefaultPii: false,
    tracesSampleRate: 0.1,
    integrations: [Sentry.browserTracingIntegration()],
    beforeSend(event) {
      if (event.request?.url) event.request.url = scrubString(event.request.url);
      if (typeof event.transaction === "string") event.transaction = scrubString(event.transaction);
      if (event.exception?.values) {
        for (const value of event.exception.values) {
          if (value.value) value.value = scrubString(value.value);
        }
      }
      return event;
    },
  });
}

export function setSentryUser(user: { id: string } | null): void {
  if (!DSN) return;
  Sentry.setUser(user);
}

export const ErrorBoundary = Sentry.ErrorBoundary;
